import EduModule from './EduModule.vue';
import EduPage from './views/EduPage.vue';
export const eduRoutes = [
  {
    path: '/edu',
    name: 'EduView',
    component: EduModule,
    children: [
      {
        path: '',
        name: 'Edu.EduPage',
        component: EduPage
      }
    ]
  }
];
